import { render, staticRenderFns } from "./SupplierWiseReport.vue?vue&type=template&id=310405f5&scoped=true&"
import script from "./SupplierWiseReport.vue?vue&type=script&lang=js&"
export * from "./SupplierWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./SupplierWiseReport.vue?vue&type=style&index=0&id=310405f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310405f5",
  null
  
)

export default component.exports